'use client'

import React, { useEffect, useId, useState, useRef } from "react"
import { useSearchParams, usePathname, useRouter } from "next/navigation"
import { useDebounceCallback } from "usehooks-ts"
import Checkbox from "@/components/form/Checkbox"
import { changeFilters, toggleFilter } from "@/services/search"
import { searchPublications } from "@/api/actions"
import RangeSlider from "@/components/form/RangeSlider"

type FiltersProps = {
    aroeven: Aroeven,
    collections: PublicationCollection[],
    expanded?: boolean
}

export default function Filters({
    aroeven,
    collections,
    expanded = false
}: FiltersProps) {

    const searchParams = useSearchParams()
    const pathname = usePathname()
    const { replace } = useRouter()
    const [facets, setFacets] = useState({})

    const changeFiltersWithDebounce = useDebounceCallback((filters: any) => {
        replace(`${pathname}?${changeFilters(searchParams, filters).toString()}`, {
            scroll: false
        })
    }, 300)

    useEffect(() => {
        async function updateFacets() {
            const { facets: newFacets } = await searchPublications(aroeven, {
                ...Object.fromEntries(searchParams),
                publishedFor: expanded ? ['federation'] : [aroeven.slug]
            })
            setFacets(newFacets)
            console.log(newFacets)
        }
        updateFacets()
    }, [searchParams])

    return (
        <>
            <aside className="sidebar filtres bg-bloc y-gap-40">
                <div className="sidebar__item">
                    <h4 className="text-18 mb-20">Collections</h4>
                    <div className="sidebar-checkbox">
                        {collections.map((collection, indexCollection) => {
                            const searchParam = 'collection'
                            return (
                                <React.Fragment key={"checkbox-" + indexCollection}>
                                    <div className="d-flex items-center justify-content-between">
                                        <Checkbox
                                            defaultChecked={searchParams.get(searchParam)?.split(',').includes(collection.id.toString()) ?? false}
                                            toggle={() => replace(`${pathname}?${toggleFilter(searchParams, searchParam, collection.id.toString()).toString()}`, {
                                                scroll: false
                                            })}
                                            label={collection.name}
                                        />
                                        <div className="col-auto">
                                            <div className="text-15 text-light-1">{searchParam in facets && Array.isArray(facets[searchParam]) && facets[searchParam].filter(f => f.value === collection.id.toString()).length > 0 ? <>{facets[searchParam].filter(f => f.value === collection.id.toString())[0].count}</> : 0}</div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )
                        })}
                    </div>
                </div>
                <div className="sidebar__item pb-30">
                    <h4 className="text-18 mb-20">Tarif</h4>
                    <div className="row x-gap-10 y-gap-30">
                        <div className="col-12">
                            <RangeSlider
                                min={parseInt(searchParams.get('minPrice') ?? "0")}
                                max={parseInt(searchParams.get('maxPrice') ?? "500")}
                                rangeMin={0}
                                rangeMax={500}
                                step={10}
                                onChange={(values: number[]) => {
                                    changeFiltersWithDebounce({
                                        minPrice: values[0],
                                        maxPrice: values[1]
                                    })
                                }}
                            />
                        </div>
                    </div>
                </div>                
                <div className="col-12 pb-0 pt-10">
                    <a href="#" onClick={(e) => {
                        e.preventDefault()
                        replace(`${pathname}`, {
                            scroll: false
                        })
                    }}>
                        <span className="info d-flex justify-content-center mt-10">
                            <i className="fi fi-ss-circle-xmark mr-5" />
                            Annuler tous les filtres
                        </span></a>
                </div>
            </aside>
        </>
    )
}